import state from './request.state'
import mutations from './request.mutations'
import actions from './request.actions'
import getters from './request.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/request/request.module.js
// module id = null
// module chunks = 